import React, { createContext, useContext } from "react";
import { getAppRole } from "../utils/appAuth";

const RoleContext = createContext({
  firebaseUser: null,
  appSession: null,
  role: null,
  isAdmin: true,
  isAgent: false,
  isSuperUser: false,
  isBroker: false,
  isFinance: false,
  appUser: null,
});

export function RoleProvider({ firebaseUser, appSession, children }) {
  const role = getAppRole(firebaseUser, appSession) || "admin";
  const value = {
    firebaseUser,
    appSession,
    role,
    isAdmin: role === "admin",
    isAgent: role === "agent",
    isSuperUser: role === "superuser",
    isBroker: role === "broker",
    isFinance: role === "finance",
    appUser: appSession?.user || null,
  };
  return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>;
}

export function useRole() {
  return useContext(RoleContext);
}
